/*****************************************************************************************************************************************************
 * Revision History
 * 2025-06-05 TBH - Set this.detailsPageUrl from hidden input that's set by Model.UploadDocumentsPageUrl.
 *****************************************************************************************************************************************************/
export default function myDocuments() {
  return {
    documentsList: [],
    passedPeopleCodeId:'',
    showErrorMesage: false,
    showLoader: false,
    detailPageUrl: '',
    formatDate( dateValue ) {
      if( dateValue != undefined && dateValue != "" && dateValue != null && dateValue != "N/A" && dateValue != 0) {
        const date = new Date(dateValue);
        const month = date.getMonth() + 1; // Month is zero-based, so add 1
        const day = date.getDate();
        const year = date.getFullYear();
        return `${month}/${day}/${year}`;
      } else {
        return dateValue;
      }
    },
  bindStudentDocumentsList() {
    fetch( '/api/Document/GetStudentDocumentsList', {
      "method": "GET" 
    }).then( response => {
      if( response.ok ) {
        return response.json()
      }
    }).then(response => {
      if (response != undefined && response.isSuccess) {
        Array.prototype.push.apply(this.documentsList, response.documents)
      } else {
        this.showErrorMesage = "An unknown error has occurred. Please try again later."
      }
    });
  },
  init() {
    this.detailPageUrl = document.getElementById( "detailPageUrl" ).value;
    this.bindStudentDocumentsList();
    }
  }
}